export default [
  {
    path: 'guide',
    name: 'guide',
    component: () => import('@/views/pages/front/Guide.vue'),
    meta: {
      pageTitle: 'Guide',
      breadcrumb: [
        {
          text: 'Guide',
          active: true,
        },
      ],
    },
  },
]
